import { ref } from 'vue'

const toasts = ref([])

export function useToast() {
  const toast = ({ title, description, variant = 'default', duration = 3000 }) => {
    const id = Date.now() + Math.random()
    toasts.value.push({ id, title, description, variant })
    
    setTimeout(() => {
      toasts.value = toasts.value.filter(t => t.id !== id)
    }, duration)
    
    return {
      id,
      dismiss: () => {
        toasts.value = toasts.value.filter(t => t.id !== id)
      },
      update: (props) => {
        const index = toasts.value.findIndex(t => t.id === id)
        if (index !== -1) {
          toasts.value[index] = { ...toasts.value[index], ...props }
        }
      }
    }
  }
  
  return { toast, toasts }
}
